import { useStore } from '@/store/zustand-solicitud';
import { ReactNode } from 'react';

const Highlight = ({ children }: { children: ReactNode }) => {
  const { color } = useStore();
  return <span style={{ color: color }}>{children}</span>;
};

export default Highlight;
